import Bugsnag from '@bugsnag/js';
import isString from 'lodash/isString';
import { Md5 } from 'ts-md5';
import { requestUrlsWithUniqueIds } from './requestUrlsWithUniqueIds';

interface IOptions {
  context: string;
  metadata?;
  severity?: 'error' | 'info' | 'warning';
}

// https://docs.bugsnag.com/platforms/javascript/reporting-handled-errors/#customizing-diagnostic-data
// TODO: fix the method signature here. The actual Bugsnag.notify() is variadic and accepts
// a variety of different inputs  e.g. (Error, null, Function) ... (Error, Function) ...
export const bugsnag = (error: string | Error, options?: IOptions) => {
  // no need to send aborted requests to bugsnag $$$
  if (typeof error === 'string' || error?.message !== 'Request aborted') {
    Bugsnag.notify(isString(error) ? new Error(error) : error, (event) => {
      event.severity = options.severity || 'error';
      event.context = options.context;

      if (options.metadata) {
        event.addMetadata(options.context, options.metadata);
        if (!requestUrlsWithUniqueIds.some((url) => options.metadata?.url.includes(url))) {
          event.groupingHash = Md5.hashStr(
            `${options.metadata?.errorCode as number}-${options.metadata?.url as string}`,
          );
        }
      }
    });
  }
};
